import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

interface Category {
  name: string;
  url: string;
  icon: string;
}

const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-hotel-bed-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-5-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-diamond-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

const navArticles = articles.map((a) => ({
  slug: a.slug,
  title: a.title.split(':')[0],
}));

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isCatDropdownOpen, setIsCatDropdownOpen] = useState(false);
  const [isArticleDropdownOpen, setIsArticleDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [mobileArticleOpen, setMobileArticleOpen] = useState(false);
  const catDropdownRef = useRef<HTMLDivElement>(null);
  const articleDropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (catDropdownRef.current && !catDropdownRef.current.contains(e.target as Node)) {
        setIsCatDropdownOpen(false);
      }
      if (articleDropdownRef.current && !articleDropdownRef.current.contains(e.target as Node)) {
        setIsArticleDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-file-excel-2-line text-lg"></i>
            </div>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-900 whitespace-nowrap">
              <strong>Itaobuy Spreadsheet</strong> Guide
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link to="/" className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-home-4-line mr-1"></i>
              Home
            </Link>

            <div className="relative" ref={catDropdownRef}>
              <button
                onClick={() => { setIsCatDropdownOpen(!isCatDropdownOpen); setIsArticleDropdownOpen(false); }}
                className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line mr-1"></i>
                Categorie
                <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${isCatDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isCatDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-72 bg-background-50 rounded-xl shadow-lg border border-background-200 py-2 max-h-80 overflow-y-auto z-50">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                        <i className={`${cat.icon} text-xs`}></i>
                      </div>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div className="relative" ref={articleDropdownRef}>
              <button
                onClick={() => { setIsArticleDropdownOpen(!isArticleDropdownOpen); setIsCatDropdownOpen(false); }}
                className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line mr-1"></i>
                Guide SEO
                <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${isArticleDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isArticleDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-80 bg-background-50 rounded-xl shadow-lg border border-background-200 py-2 max-h-80 overflow-y-auto z-50">
                  <Link
                    to="/articolo/guida-completa-itaobuy-spreadsheet"
                    onClick={() => setIsArticleDropdownOpen(false)}
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 flex-shrink-0">
                      <i className="ri-star-line text-xs"></i>
                    </div>
                    Guida Completa
                  </Link>
                  {navArticles.map((a) => (
                    <Link
                      key={a.slug}
                      to={`/articolo/${a.slug}`}
                      onClick={() => setIsArticleDropdownOpen(false)}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                        <i className="ri-article-line text-xs"></i>
                      </div>
                      {a.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/articolo/guida-completa-itaobuy-spreadsheet"
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line mr-1"></i>
              Guida
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-guide-line mr-1"></i>
              Guida agli Acquisti
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="ml-2 px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Visita il Sito Ufficiale
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="Menu"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 max-h-[70vh] overflow-y-auto">
          <div className="flex flex-col gap-0.5">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-xl transition-colors cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                <i className="ri-home-4-line"></i>
              </div>
              Home
            </Link>

            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-xl transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                  <i className="ri-shopping-bag-3-line"></i>
                </div>
                Categorie
              </span>
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {mobileCatOpen && (
              <div className="ml-4 mb-2 border-l-2 border-primary-200 pl-4 space-y-0.5">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50/50 cursor-pointer"
                  >
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <button
              onClick={() => setMobileArticleOpen(!mobileArticleOpen)}
              className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-xl transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                  <i className="ri-book-open-line"></i>
                </div>
                Guide SEO
              </span>
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${mobileArticleOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {mobileArticleOpen && (
              <div className="ml-4 mb-2 border-l-2 border-accent-200 pl-4 space-y-0.5">
                <Link
                  to="/articolo/guida-completa-itaobuy-spreadsheet"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50/50 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 flex-shrink-0">
                    <i className="ri-star-line text-xs"></i>
                  </div>
                  Guida Completa
                </Link>
                {navArticles.map((a) => (
                  <Link
                    key={a.slug}
                    to={`/articolo/${a.slug}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50/50 cursor-pointer"
                  >
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                      <i className="ri-article-line text-xs"></i>
                    </div>
                    {a.title}
                  </Link>
                ))}
              </div>
            )}

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-xl transition-colors cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                <i className="ri-guide-line"></i>
              </div>
              Guida agli Acquisti
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-2 mx-4 px-5 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all text-center cursor-pointer"
            >
              Visita il Sito Ufficiale
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}